import { FC } from 'react'
import useCopyToClipboard from 'hooks/useCopyToClipboard'
import { getPostRoute } from 'helpers/routes'
import useActionGuard from 'hooks/useActionGuard'
import { Post } from '@wellesley/openapi'
import { CardAction } from '../../feed/Feed/Footer/CardAction'
import { Link2 } from 'lucide-react'
import BookmarkButton from '../../bookmarks/BookmarkButton'
import formatNumber from 'helpers/formatNumber'
import { staticState } from '@wellesley/host-remote'
import { TooltipWrapper } from '@wellesley/ui'

const Footer: FC<Post> = (post) => {
  const { isDisabled, ActionTooltipWrapper } = useActionGuard()
  const baseUrlParam = staticState.get().baseUrl
  const [copyPostLink] = useCopyToClipboard({
    textToCopy: `${baseUrlParam}${getPostRoute(post.author, post.id)}`,
    toastMsg: 'Link successfully copied',
  })
  const handleShare = () => void copyPostLink()

  return (
    <div className="h-m md:h-xxs md:gap-xl flex max-md:justify-between">
      <p className="text-sm text-gray-500">
        {formatNumber(post.stats.comments || 0)} replies
        {' ・ '}
        {formatNumber(
          (post?.votes?.upvotes || 0) - (post?.votes?.downvotes || 0),
        )}{' '}
        votes
        {' ・ '}
        {formatNumber(post.stats.likes || 0)} likes
      </p>
      <ActionTooltipWrapper>
        <CardAction
          name="share"
          handler={handleShare}
          disabled={isDisabled}
          className="md:ml-auto"
        >
          <TooltipWrapper
            theme="dark"
            size="small"
            tooltipText={isDisabled ? '' : 'Share'}
          >
            <Link2 size={20} color="var(--gray-600)" />
          </TooltipWrapper>
        </CardAction>
      </ActionTooltipWrapper>
      <BookmarkButton postId={post.id} isBookmarked={!!post.bookmarked} />
    </div>
  )
}

export default Footer
